import { provide, computed } from "vue"
import { useI18n } from "vue-i18n"
import { useStore } from "vuex"

export const useFtkDataProvider = () => {
    const { t } = useI18n()
    const store = useStore()

    function provideFtkFields() {
        const ftkI18nEntries = {
            bold: computed(() => t("common.bold")),
            italic: computed(() => t("common.italic")),
            underline: computed(() => t("common.underline")),
            textStrikeThrough: computed(() => t("common.textStrikeThrough")),
            textSize: computed(() => t("common.textSize")),
            textFormat: computed(() => t("common.textFormat")),
            textColor: computed(() => t("common.textColor")),
            alignLeft: computed(() => t("common.alignLeft")),
            alignCenter: computed(() => t("common.alignCenter")),
            alignRight: computed(() => t("common.alignRight")),
            alignJustify: computed(() => t("common.alignJustify")),
            textAlign: computed(() => t("common.textAlign")),
            url: computed(() => t("common.url")),
            textList: computed(() => t("common.textList")),
            formatClear: computed(() => t("common.formatClear")),
            emoji: computed(() => t("common.emoji")),
            sizeSmall: computed(() => t("common.sizeSmall")),
            sizeNormal: computed(() => t("common.sizeNormal")),
            sizeLarge: computed(() => t("common.sizeLarge")),
            sizeHuge: computed(() => t("common.sizeHuge")),
        }

        provideEntries({ entries: ftkI18nEntries, name: "i18n" })
    }

    function provideEntries({ entries, name }) {
        const primaryColor = computed(() => {
            return store.getters["theme/primaryColor"]
        })

        provide("ftk.inputColor.extraDefaultColor", primaryColor)
        provide("ftk.modalPlugin.logErrors", true)

        // For each entry, we are creating a symbol and providing it globally so ftk library can access to it.
        try {
            Object.entries(entries).forEach(([key, value]) => {
                provide(`ftk.${name}.${key}`, value)
            })
        } catch (error) {
            throw new Error(`Providing entries failed with error: ${error}`)
        }
    }

    return {
        provideFtkFields,
    }
}
